import React, { useState } from 'react';
import { useOnce } from '@root/src/web/lib/useOnce';
import { pickMessage, } from '@root/src/web/lib/messagePicker';
import { ReaderRevenueEpic, canShow as canShowReaderRevenueEpic, } from './ReaderRevenueEpic';
import { MaybeBrazeEpic, canShow as canShowBrazeEpic } from './BrazeEpic';
const buildReaderRevenueEpicConfig = ({ isSignedIn, countryCode, contentType, sectionName, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, }) => {
    return {
        candidate: {
            id: 'reader-revenue-banner',
            canShow: () => canShowReaderRevenueEpic({
                isSignedIn,
                countryCode,
                contentType,
                sectionName,
                shouldHideReaderRevenue,
                isMinuteArticle,
                isPaidContent,
                tags,
                contributionsServiceUrl,
            }),
            show: (meta) => () => {
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                return React.createElement(ReaderRevenueEpic, Object.assign({}, meta));
            },
        },
        timeoutMillis: null,
    };
};
const buildBrazeEpicConfig = (brazeMessages, contributionsServiceUrl, countryCode) => {
    return {
        candidate: {
            id: 'braze-epic',
            canShow: () => canShowBrazeEpic(brazeMessages),
            show: (meta) => () => (React.createElement(MaybeBrazeEpic, { meta: meta, contributionsServiceUrl: contributionsServiceUrl, countryCode: countryCode })),
        },
        timeoutMillis: null,
    };
};
export const SlotBodyEnd = ({ isSignedIn, countryCode, contentType, sectionName, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, brazeMessages, }) => {
    const [SelectedEpic, setSelectedEpic] = useState(null);
    useOnce(() => {
        const readerRevenueEpic = buildReaderRevenueEpicConfig({
            isSignedIn,
            countryCode,
            contentType,
            sectionName,
            shouldHideReaderRevenue,
            isMinuteArticle,
            isPaidContent,
            tags,
            contributionsServiceUrl,
        });
        const brazeEpic = buildBrazeEpicConfig(brazeMessages, contributionsServiceUrl, countryCode);
        const epicConfig = {
            candidates: [readerRevenueEpic, brazeEpic],
            name: 'slotBodyEnd',
        };
        pickMessage(epicConfig)
            .then((PickedEpic) => setSelectedEpic(PickedEpic))
            .catch((e) => console.error(`SlotBodyEnd pickMessage - error: ${e}`));
    }, [isSignedIn, countryCode, brazeMessages]);
    if (SelectedEpic) {
        return React.createElement(SelectedEpic, null);
    }
    return null;
};
